import { lazy } from 'react';

import type { CmsApiFormBuilderBlockData } from '#/modules/cms/api/types/blocks/CmsApiFormBuilderBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';

export const CmsFormBuilderBlockMapping: CmsBlockMapping<CmsApiFormBuilderBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: lazy(() =>
      import('./CmsFormBuilderBlock').then((m) => ({
        default: m.CmsFormBuilderBlock,
      })),
    ),
  };
